import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useCart } from "./CartContext";
import "../styles/ProductDetail.css";

// Product data
const products = [
  { 
    id: 1, 
    name: "Bubble Gum", 
    image: "/images/product1-img1.png", 
    price: 109000,
    images: ["/images/product1-img1.png", "/images/product1-img2.png"],
    description: "A playful and sweet fragrance that captures the essence of childhood nostalgia. Light, bubbly, and irresistibly charming."
  },
  { 
    id: 2, 
    name: "Ret Vanilla", 
    image: "/images/product2-img1.png", 
    price: 79000,
    images: ["/images/product2-img1.png", "/images/product2-img2.png"],
    description: "A warm and comforting vanilla scent that wraps you in a soft, sweet embrace. Perfect for those who love classic, inviting fragrances."
  },
  { 
    id: 3, 
    name: "Romant Wis", 
    image: "/images/product5-img1.png", 
    price: 79000,
    images: ["/images/product5-img1.png", "/images/product5-img2.png"],
    description: "A romantic and dreamy fragrance that whispers of love and subtle passion. Ideal for elegant evening occasions."
  },
  { 
    id: 4, 
    name: "Vanilla Cake", 
    image: "/images/product6-img1.png", 
    price: 89000,
    images: ["/images/product6-img1.png", "/images/product6-img2.png"],
    description: "Indulgent and sweet, this fragrance is like a slice of freshly baked vanilla cake. Warm, rich, and utterly delectable."
  }
];

const ProductDetail = () => {
  const { id } = useParams();
  const [mainImage, setMainImage] = useState(0);
  const { addToCart } = useCart();

  // Find the specific product based on the ID from the URL
  const product = products.find(p => p.id === parseInt(id || '0'));

  // If no product is found, show an error
  if (!product) {
    return <div>Product not found</div>;
  }

  const formatToIDR = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
    }).format(amount);
  };

  const handleAddToCart = () => {
    addToCart(product);
  };

  return (
    <div className="product-detail container">
      <div className="image-slider">
        <div className="main-image">
          <img
            src={product.images[mainImage]}
            alt={`${product.name} - Main`}
            onClick={() => setMainImage((prev) => (prev + 1) % product.images.length)}
          />
        </div>
        <div className="thumbnail-images">
          {product.images.map((image, index) => (
            <div
              className={`thumbnail-image ${index === mainImage ? "active" : ""}`}
              key={index}
              onClick={() => setMainImage(index)}
            >
              <img src={image} alt={`${product.name} - ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
      <div className="product-info">
        <h1>{product.name}</h1>
        <p className="product-price">{formatToIDR(product.price)}</p>
        <p className="product-description">{product.description}</p>
        <button className="btn" onClick={handleAddToCart}>Add to Cart</button>
      </div>
    </div>
  );
};

export default ProductDetail;